<template>
  <section class="c-user-wallets">
    <card class="data-card wallets" :show-footer-line="true">
      <h1 class="card-header p-0 card-header-text pb-3">کیف پول‌ها</h1>
      <div>
        <b-skeleton-table
          v-if="loading"
          :rows="10"
          :columns="4"
          :table-props="{ bordered: true, striped: true }"
        >
        </b-skeleton-table>

        <b-row v-if="!loading">
          <b-col md="6" cols="12" class="my-1">
            <b-input-group class="mb-2">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                class="text-input"
                placeholder="جستجو"
              >
              </b-form-input>

              <template v-if="filter" #append>
                <b-button
                  class="p-0 no-shadow clear-input-button"
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  پاک کردن
                </b-button>
              </template>
            </b-input-group>
          </b-col>

          <b-col class="no-col-margin" md="12">
            <b-card class="wallets-table" no-body>
              <b-table
                empty-text="موردی یافت نشد"
                :items="items"
                :current-page="currentPage"
                :per-page="perPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                stacked="md"
                empty-filtered-html="نتیجه ای برای جستجوی شما یافت نشد"
                show-empty
                small
              >
                <template #cell(symbol)="row">
                  {{ row.item.symbol.toUpperCase() }}
                </template>

                <template #cell(amount)="row">
                  <!-- <span v-if="row.item.amount % 1 == 0">
                  {{ parseFloat(row.item.amount) }}
                </span>
                <span v-else>
                  {{ parseFloat(row.item.amount).toFloatFix(7) }}
                </span> -->
                  {{ row.item.amount }}
                </template>

                <template #cell(name)="row">
                  <div class="icon-container">
                    <CryptoIcons
                      class="ml-3"
                      :symbol="row.item.symbol"
                      size="30"
                    />
                    {{ row.item.symbol }}
                  </div>
                </template>

                <template #cell(actions)="row" v-if="isSuperAdmin">
                  <b-row class="text-center" no-gutters>
                    <b-button

                      size="sm"
                      variant="primary"
                      class="p-2 pl-4 pr-4"
                      @click="$bvModal.show('modal-' + row.item.symbol)"
                    >برداشت و واریز
                    </b-button
                    >
                    <b-modal
                      :hide-footer="true"
                      :id="'modal-' + row.item.symbol"
                      :title="'برداشت و واریز' + ' ' + row.item.symbol"
                    >
                      <template #default="{}">
                        <div class="text-right">
                          <h2></h2>
                          <h2>توضیحات برداشت یا واریز:</h2>
                          <textarea v-model="details" class="w-100"></textarea>
                          <small class="pb-3 d-block text-red"
                          >نوشتن توضیحات برداشت یا واریز الزامی است‌
                            است.</small
                          >
                          <div class="d-flex align-items-center justify-content-start align-content-center mb-3">
                            <b-form-checkbox v-model="sendFraudEvent"/>
                            <label class="mb-0 mr-2" for=""> کنترل برداشت</label>
                          </div>

                          <div class="d-flex py-2">
                            <input
                              type="number"
                              v-model="items[row.index].increase"
                            />


                            <b-button
                              variant="primary"
                              :disabled="!details || details === ' '"
                              @click="
                                handleIncrease(
                                  row.item.symbol,
                                  items[row.index].increase
                                )
                              "
                              size="sm"
                              class="btn table-link mr-1"
                            >
                              واریز {{ row.item.symbol }}
                            </b-button>
                          </div>
                          <div class="d-flex py-2">
                            <input
                              type="number"
                              v-model="items[row.index].decrease"
                            />
                            <b-button
                              variant="primary"
                              :disabled="!details || details === ' '"
                              @click="
                                handleDecrease(
                                  row.item.symbol,
                                  items[row.index].decrease
                                )
                              "
                              size="sm"
                              class="btn table-link mr-1"
                            >
                              برداشت {{ row.item.symbol }}
                            </b-button>
                          </div>
                        </div>
                      </template>
                    </b-modal>
                  </b-row>
                </template>
              </b-table>
            </b-card>
            <div class="paginationNav">
              <b-row no-gutters>
                <b-col class="mt-4">
                  <div class="overflow-auto">
                    <b-pagination
                      align="center"
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                    >
                    </b-pagination>
                  </div>
                </b-col>
              </b-row>
            </div>
            <br/>
          </b-col>
        </b-row>
      </div>
    </card>
  </section>
</template>
<script>
import http from "@/httpservices/HttpService"
import CryptoIcons from "@/components/CryptoIcons";
// import { toFloatFix } from "@/utils/NumberTools"
import store from '@/store';

export default {

  components: {
    CryptoIcons,
  },

  data() {
    return {
      items: [],
      loading: false,

      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      details: "",
      sendFraudEvent: true,

      fields: [
        {
          key: "name",
          label: "نام",
          sortable: false,
          sortDirection: "desc",
          class: "text-right",
        },
        {
          key: "symbol",
          label: "رمز ارز",
          sortable: false,
          sortDirection: "desc",
          class: "text-right",
        },

        {
          key: "amount",
          label: "موجودی",
          sortable: true,
          class: "",
        },

        {key: "actions", label: ""},
      ],

      filter: null,
      filterOn: [],
      userBoxArrow: "chevron-down",
      increase: 0,
      decrease: 0,
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return {text: f.label, value: f.key};
        });
    },
    isSuperAdmin() {
      return store.getters['isSuperAdmin']
    }
  },

  mounted() {
    this.getWallets();
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      this.details = "";
    });
  },

  methods: {
    handleDecrease(symbol, amount) {
      this.loading = true;
      http.put("/Wallets/" + this.$route.params.id + "/asset/" + symbol + "/decrease", {
        amount: amount + "",
        details: this.details,
        sendFraudEvent: this.sendFraudEvent,
      })
        .then(() => {
          this.loading = false;
          this.details = "";
          this.sendFraudEvent = true;
          this.$bvModal.hide("modal-" + symbol);
          this.getWallets();
          this.$swal({
            position: "top-end",
            icon: "success",
            title: "عملیات با موفقیت انجام شد",
            showConfirmButton: false,
            timer: 1500,
            toast: true,
          });

          // update user transactionReport list
          this.$root.$emit("manualWalletsAction");
        })
        .catch((err) => {
          this.loading = false;

          if (err.response.data.title == "INSUFFICIENT_CREDIT") {
            this.$swal({
              position: "center",
              icon: "error",
              title: "موجودی حساب کافی نیست",
              showConfirmButton: false,
              timer: 1500,
            });
          }

          this.details = "";
          let errorResponse = this.errorHandler(err);
        });
    },

    handleIncrease(symbol, amount) {
      this.loading = true;
      http.put("/Wallets/" + this.$route.params.id + "/asset/" + symbol + "/increase", {
        amount: amount + "",
        details: this.details,
        sendFraudEvent: this.sendFraudEvent,
      })
        .then((response) => {
          this.loading = false;
          this.details = "";
          this.sendFraudEvent = true;
          this.$bvModal.hide("modal-" + symbol);
          this.getWallets();
          this.$swal({
            position: "top-end",
            icon: "success",
            title: "عملیات با موفقیت انجام شد",
            showConfirmButton: false,
            timer: 1500,
            toast: true,
          });
          // update user transactionReport list
          this.$root.$emit("manualWalletsAction");
        })
        .catch((err) => {
          this.loading = false;
          this.details = "";
          let errorResponse = this.errorHandler(err);
        });
    },

    linkGen(pageNum) {
      return `/wallet/wallet-list/${pageNum}`;
    },

    pageGen(pageNum) {
      return pageNum;
    },

    getWallets() {
      this.loading = true;

      http.get("/Wallets/" + this.$route.params.id,)
        .then((response) => {
          this.items = [];

          response.data.forEach((element) => {
            if (element.symbol == "IRT") {
              this.items.push({
                symbol: element.symbol,
                name: element.name,
                amount: element.amount,
                priority: 1,
                increase: null,
                decrease: null,
              });
            } else if (element.symbol == "IRTV") {
              this.items.push({
                symbol: element.symbol,
                name: element.name,
                amount: element.amount,
                priority: 2,
                increase: null,
                decrease: null,
              });
            } else if (element.symbol == "BTC") {
              this.items.push({
                symbol: element.symbol,
                name: element.name,
                amount: element.amount,
                priority: 3,
                increase: null,
                decrease: null,
              });
            } else {
              this.items.push({
                symbol: element.symbol,
                name: element.name,
                amount: element.amount,
                priority: 4,
                increase: null,
                decrease: null,
              });
            }
          });

          this.items.sort((a, b) => {
            return a.priority - b.priority;
          });

          this.items.sort((a, b) => {
            return b.amount - a.amount;
          });

          this.totalRows = this.items.length;
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },

};
</script>
<style lang="scss">
.c-user-wallets {
  .modal-header .close {
    margin: -1rem -1rem -1rem -1rem !important;
  }

  .wallets {
    table {
      td {
        vertical-align: middle !important;
      }
    }
  }

  #filter-input {
    .input-group-append {
      padding-top: 0 !important;
    }
  }

  .no-shadow {
    box-shadow: none;
    background-color: #fff;
  }

  .no-shadow:hover {
    box-shadow: none;
    background-color: #fff;
  }

  .card-detail-container {
    .row {
      margin-bottom: 18px;
    }

    .last {
      margin-bottom: 0;
    }

    .info {
      font-size: 16px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #757575;
      text-align: right;
      margin-bottom: 8px;
    }

    .value {
      font-size: 16px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #000;
      text-align: left;
    }
  }

  .bank-logo {
    width: 34px;
    height: 34px;
  }

  .more-info-header-button {
    background-color: #fff;
  }

  @media (max-width: 990.99px) {
    .clear-input-button {
      font-size: 12px;
      //  margin-top: -12;
    }

    .section-header {
      font-size: 24px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #757575;
      margin-bottom: 49px;
    }

    .icon-container {
      div {
        margin-bottom: 16px;

        svg {
          margin-left: 0 !important;
        }
      }
    }
  }

  @media (min-width: 991px) {
    .icon-container {
      display: flex;
    }

    .section-header {
      font-size: 24px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #757575;
      margin-bottom: 49px;
    }
  }

  #add-card-modal {
    .modal-body {
      text-align: right;
      direction: rtl;
    }
  }
}
</style>
